import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PENDING_APPOINTMENTS_LIST = 'GET_PENDING_APPOINTMENTS_LIST';
export const GET_PENDING_APPOINTMENTS_LIST_SUCCESS =
  'GET_PENDING_APPOINTMENTS_LIST_SUCCESS';
export const GET_PENDING_APPOINTMENTS_LIST_FAILURE =
  'GET_PENDING_APPOINTMENTS_LIST_FAILURE';

// Action Creators
export const getPendingAppointmentsList = () => ({
  type: GET_PENDING_APPOINTMENTS_LIST,
});

export const getPendingAppointmentsListSuccess = (users) => ({
  type: GET_PENDING_APPOINTMENTS_LIST_SUCCESS,
  payload: users,
});

export const getPendingAppointmentsListFailure = (error) => ({
  type: GET_PENDING_APPOINTMENTS_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getPendingAppointmentsListData = (external, pageCount) => {
  return async (dispatch) => {
    dispatch(getPendingAppointmentsList());
    try {
      const requestUrl =
        pageCount !== undefined
          ? `${url?.pendingAppointments}?page=${pageCount}`
          : url?.pendingAppointments;
      const response = await getMethodWithToken(requestUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getPendingAppointmentsListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getPendingAppointmentsListFailure(error?.message));
    }
  };
};
